<template>
  <router-view></router-view>
</template>
<script>
export default {
  name: 'EmptyPageView'
}
</script>



// WEBPACK FOOTER //
// src/views/common/EmptyPageView.vue